<template>
  <div>
    <div class="user-roles">
      <div class="user-roles__search">
        <base-input
          v-model="searchBar"
          inputType="text"
          labelText="Kullanıcı ara"
          placeholder="Müşteri No"
          @enter="getUserList"
        />
        <base-button class="search-button" @click="getUserList"
          >Ara</base-button
        >
        <base-button class="add-button" @click="showModal('add-user')"
          >İç Kullanıcı Ekle</base-button
        >
      </div>
      <div class="user-roles__content">
        <table class="table" aria-describedby="logs">
          <thead>
            <th v-for="item in packagesHeader" :key="item.id">
              <span v-if="item == 'representativeTag'">Temsilci Etiketi</span>
              <span v-if="item == 'branchTitle'">Şube</span>
              <span v-if="item == 'customerNo'">Kullanıcı Numarası</span>
              <span v-if="item == 'name'">Adı</span>
              <span v-if="item == 'surName'">Soyadı</span>
              <span v-if="item == 'phoneNumber'">Telefon Numarası</span>
              <span v-if="item == 'email'">Email</span>
            </th>
          </thead>
          <tbody v-if="allPackages.data && allPackages.data.length">
            <tr v-for="item in allPackages.data" :key="item.customerNo">
              <td v-if="item.representativeTag">
                {{ item.representativeTag }}
              </td>
              <td v-else>-</td>
              <td v-if="item.branchTitle">{{ item.branchTitle }}</td>
              <td v-else>-</td>
              <td v-if="item.customerNo">{{ item.customerNo }}</td>
              <td v-else>-</td>
              <td v-if="item.name">{{ item.name }}</td>
              <td v-else>-</td>
              <td v-if="item.surName">{{ item.surName }}</td>
              <td v-else>-</td>
              <td v-if="item.phoneNumber">{{ item.phoneNumber }}</td>
              <td v-else>-</td>
              <td v-if="item.email">{{ item.email }}</td>
              <td v-else>-</td>

              <td>
                <div @click="removeUser(item.customerNo)" class="remove-button">
                  Kaldır
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td v-bind:colspan="packagesHeader.length">
                Aradığınız kullanıcı iç kullanıcı listesinde bulunamadı
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Pager
      :pageName="'usersRole'"
      :page="allPackages.page"
      v-if="allPackages.page"
      @refreshUsersRole="isPageRefreshed"
    />

    <modal height="auto" class="user-modal" :adaptive="true" :name="modalName">
      <div class="modal-heading">
        <div class="modal-title">
          <h5>Yeni İç Kullanıcı Ekle</h5>
        </div>
        <a @click="closeModal(modalName)"></a>
      </div>
      <div class="modal-body">
        <div class="modal-body__top">
          <div class="modal-body__detail">
            <base-input
              v-model="modalForm.add.newUser"
              inputType="text"
              labelText="Yeni Kullanıcı"
            />
          </div>
        </div>
      </div>
      <div class="modal-bottom">
        <base-button class="success" @click="addUser">Evet</base-button>
        <base-button class="warning" @click="closeModal(modalName)"
          >Hayır</base-button
        >
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import { BaseInput, Pager, BaseButton } from "@/components";

export default {
  name: "UsersRole",
  data() {
    return {
      allPackages: [],
      modalName: "",
      packagesHeader: [],
      isPagerChanged: false,
      searchBar: "",
      modalForm: {
        add: {
          newUser: "",
        },
      },
    };
  },
  components: {
    BaseButton,
    BaseInput,
    Pager,
  },
  methods: {
    ...mapActions([
      "userRoleGetUsersList",
      "userRoleAddNewUser",
      "userRoleRemoveInternalUser",
    ]),
    ...mapMutations(["setUserRoleFilter"]),
    ...mapGetters(["userRoleFilter"]),
    getUserList() {
      if (this.searchBar != "") {
        this.setUserRoleFilter({
          filter: { CustomerNo: this.searchBar },
          page: 1,
          size: 10,
        });
      } else {
        delete this.userRoleFilter().filter;
      }
      this.userRoleGetUsersList().then((response) => {
        if (response.error) {
          this.$toast.error(response.message);
        } else {
          this.allPackages = response;
          if (this.allPackages.data) {
            this.packagesHeader =
              this.allPackages.data.length > 0
                ? Object.keys(this.allPackages.data[0])
                : "";
          }
        }
      });
    },
    addUser() {
      this.userRoleAddNewUser({ customerNo: this.modalForm.add.newUser }).then(
        (response) => {
          if (!response) {
            this.$toast.success("Başarılı şekilde eklendi.");
            this.$modal.hide(this.modalName);
            this.getUserList();
          } else {
            this.$toast.error(response.message);
          }
        }
      );
    },
    removeUser(customerNo) {
      this.userRoleRemoveInternalUser({ customerNo: customerNo }).then(
        (response) => {
          if (!response) {
            this.$toast.success("Başarılı şekilde kaldırıldı.");
            this.getUserList();
          } else {
            this.$toast.error(response.message);
          }
        }
      );
    },
    showModal(param) {
      this.modalName = String(param);
      this.$nextTick(() => {
        this.$modal.show(this.modalName);
      });
    },
    closeModal(param) {
      this.$nextTick(() => {
        this.$modal.hide(param);
      });
      this.modalName = "";
    },
    isPageRefreshed(data) {
      this.isPagerChanged = data;
    },
  },
  mounted() {
    this.getUserList();
  },
  watch: {
    isPagerChanged: {
      handler() {
        this.getUserList();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.user-roles {
  position: relative;
  padding: 10px;
  &__add_user {
    display: flex;
    justify-content: flex-end;
  }
  &__search {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    justify-content: flex-end;
    ::v-deep .base-form-input {
      width: 300px;
      input {
        height: 48px;
      }
    }
    .search-button {
      max-width: 150px;
    }
    .add-button {
      max-width: 150px;
    }
    @media (max-width: 768px) {
      display: block;
      .add-button,
      .search-button {
        max-width: 100%;
        display: block;
        margin: 10px 0px;
      }

      .base-form-input {
        width: 100%;
      }
    }
  }
  &__content {
    position: relative;
    @media (max-width: 992px) {
      overflow-x: scroll;
    }
    .loader-icon {
      right: auto;
    }
    .table {
      border-collapse: collapse;
      text-indent: 0;
      border-color: inherit;
      min-width: 100%;
      border-radius: var(--radius-second) !important;
      overflow-x: hidden;
      border: solid 1px #e9e9eb;
      background-color: #fff;
      margin: 20px 0;
      overflow-y: visible !important;
      .remove-button {
        background-color: var(--color-warning);
        color: var(--grayscale-0);
        padding: 5px;
        border: 1px solid var(--color-warning);
        border-radius: 5px;

        transition: all 0.2s ease-in;
        cursor: pointer;
        &:hover {
          background-color: var(--grayscale-0);
          color: var(--color-warning);
        }
      }
      @media (max-width: 1024px) {
        overflow-x: scroll;
      }
      th,
      td {
        font-size: 14px;
        padding: 18px 12px;
        vertical-align: middle;
        border-top: 1px solid #e8e8e8;
        text-align: center;
      }
      tbody {
        tr td:first-child {
          width: 20px;
        }
      }
    }
  }
}

.user-modal {
  z-index: 9999;

  ::v-deep .vm--modal {
    overflow-y: scroll;
    @media (max-width: 1024px) {
      width: 90% !important;
      left: 50% !important;
      transform: translateX(-50%);
    }
  }
  .multi_select {
    display: block;
    margin: 0px auto 20px auto;
    max-width: 600px;
    position: relative;

    ::v-deep .month-closing-selectbox {
      width: 100%;
      .vs__dropdown-toggle {
        min-height: 50px;
        border: 1px solid #41807a;
        height: auto;
      }
      .vs__selected {
        &:first-child {
          margin-left: 0px;
        }
        margin: 3px;
        padding: 10px;
        margin-bottom: 0px;
      }
      ul[role="listbox"] {
        height: 110px;
        overflow-y: scroll;
      }
    }
    .select_button {
      border-radius: 7px;
      padding: 10px;
      max-width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      margin-bottom: 5px;
      cursor: pointer;
      background-color: #41807a;
      color: #fff;
    }
    p {
      margin-top: 10px;
      font-size: 12px;
      color: #41807a;
    }
  }
  .modal-heading {
    height: 40px;
    border-bottom: 1px solid var(--grayscale-30);
    display: flex;
    align-items: center;
    padding: 15px 30px;
    justify-content: space-between;
    .close {
      margin: 5px;
      cursor: pointer;
    }
  }
  .modal-bottom {
    margin-top: 1em;
    border-top: 1px solid var(--grayscale-30);
    display: flex;
    justify-content: space-between;
    padding: 15px 30px;
    .base-button {
      background-color: var(--color-primary-default);
      color: var(--grayscale-0);
      width: 180px;
      font-size: 15px;
      &.warning {
        background-color: var(--color-warning);
      }
    }
  }
  .modal-body {
    padding: 15px 30px;
    &__top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &__image {
      .image {
        margin-right: 30px;
        width: 96px;
        height: 140px;
        -o-object-fit: contain;
        object-fit: contain;
      }
    }
    &__detail {
      width: 100%;
      margin-top: 20px;
      .base-form-input {
        ::v-deep input {
          height: 40px;
        }
      }
      .accordion {
        position: relative;
        &__button {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #000;
          padding: 10px 0px;
          padding-bottom: 0px;
          margin-bottom: 20px;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
        }
        &__content {
          &__wrapper {
            &__title {
              font-size: 14px;
              font-weight: bold;
              text-decoration: underline;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
